<template>
  <div class="flex min-h-screen bg-primaryBg font-inter">
    <aside class="hidden md:block w-[294px] flex-shrink-0 bg-primaryBg text-primaryDark">
      <Sidebar />
    </aside>
    <div class="flex-grow">
      <main class="w-full">
        <CreateEventComponent />
      </main>
    </div>
  </div>
</template>

<script>
import Sidebar from '@/components/SidebarComponent.vue';
import CreateEventComponent from '@/components/explore/CreateEventComponent.vue';

export default {
  name: 'CreateEvent',
  components: { Sidebar, CreateEventComponent },
  mounted() { window.scrollTo(0, 0); }
}
</script>

<style scoped>
</style>